import { Helper } from '@/services/helper/helper';

class TrackingInterface {
	constructor () {
		this.trackTif();
		this.pointOfViewFlag = false;
		this.init();
		this.trackMe = window.piTracking.trackMe;
	}

	init () {
		if (!window.SiteInfo) {
			window.SiteInfo = {};
		}
		if (!window.SiteInfo.TrackLibPageId) {
			window.SiteInfo.TrackLibPageId = Date.now();
		}

		document.addEventListener('pageReady', (event) => {
			// Event Teaserpixel
			this.trackTeaserPixel();

			this.setBlockNumber();
			this.addHashTracking();
		});
	}

	setBlockNumber () {
		// count all section elements in data-content + header + billboard if exists
		let count = 1; // header is first (at the moment. BillboardPosition could become first in the future.)
		document.querySelector('.main-content > [data-component="header"]').setAttribute('data-block-number', count);

		let billboardPosition = document.querySelector('.main-content > [data-service-slot="middle"]');
		if (billboardPosition) {
			count++;
			billboardPosition.setAttribute('data-block-number', count);
		}

		let contentLogin = document.querySelector('.main-content > [data-component="login"]');
		if (contentLogin) {
			count++;
			contentLogin.setAttribute('data-block-number', count);
		}

		let sections = document.querySelectorAll('.main-content > [data-content] > section');
		sections.forEach((element) => {
			count++;
			element.setAttribute('data-block-number', count);

			let parentBlockNavigation = element.previousElementSibling;
			if (parentBlockNavigation && parentBlockNavigation.matches('[data-component="block-navigation"]')) {
				parentBlockNavigation.setAttribute('data-block-number', count);

				if (element.hasAttribute('data-name')) {
					parentBlockNavigation.setAttribute('data-name', element.getAttribute('data-name'));
				}
				if (element.hasAttribute('data-layout-name')) {
					parentBlockNavigation.setAttribute('data-layout-name', element.getAttribute('data-layout-name'));
				}
			}
			this.setTeaserNumber(element);
		});
	}

	setTeaserNumber (blockElement) {
		// if teaser is in pointOfView section -> start at 0
		let allTeasers = blockElement.querySelectorAll('[data-component="teaser"]');
		if (allTeasers.length) {
			let checkPointOfView = false;
			let leftSlider = false;
			let indexRemoval = 0;
			if (this.getParentElement(allTeasers[0], '[data-name="viewport"]')) {
				checkPointOfView = true;
			}

			allTeasers.forEach((teaser, index) => {
				if (checkPointOfView && !leftSlider) {
					if (!this.getParentElement(teaser, '[data-component="slider"]')) {
						leftSlider = true;
						indexRemoval = index;
					}
				}
				teaser.setAttribute('data-teaser-number', index - indexRemoval);
			});
		}
	}

	trackTeaserPixel () {
		const sliderTeasers = Array.from(document.querySelectorAll('[data-name="viewport"] [data-component="slider"] [data-component="teaser"]'));
		const otherViewportTeasers = Array.from(document.querySelectorAll('[data-name="viewport"] [data-component="list"] [data-component="teaser"], [data-name="viewport"] > [data-component="teaser"]'));
		const recommendationTeasers = Array.from(document.querySelectorAll('[data-name="Recommendation"] [data-component="teaser"]'));

		// There are hidden teasers in the viewport for other colcases. We should not count them of course
		const otherVisibleViewportTeasers = otherViewportTeasers.filter((element) => {
			return Helper.isElementVisible(element);
		});
		const recommendationVisibleTeasers = recommendationTeasers.filter((element) => {
			return Helper.isElementVisible(element);
		});

		const teaserTrack = [];

		// add 'hero' to everything in slider
		sliderTeasers.forEach((teaser, index) => {
			teaserTrack.push('hero,' + index + ',' + teaser.getAttribute('data-teaser-id'));
		});

		// add pointOfViewTeaser to everything else in viewport
		otherVisibleViewportTeasers.forEach((teaser, index) => {
			let appendReco = this.getReco() && teaser.getAttribute('data-reco-teaser') === '1' ? '_treatSimple' : '';
			teaserTrack.push('pointOfViewTeaser' + appendReco + ',' + index + ',' + teaser.getAttribute('data-teaser-id'));
		});

		recommendationVisibleTeasers.forEach((teaser, index) => {
			const appendReco = this.getReco() && teaser.getAttribute('data-reco-teaser') === '1' ? '_treatSimple' : '';
			teaserTrack.push('Recommendation' + appendReco + ',' + index + ',' + teaser.getAttribute('data-teaser-id'));
		});

		const teaserTrackString = teaserTrack.join('|');

		const currentEvent = window.initialData.serviceResponse.response.type;

		let brandInTracking = window.SiteInfo.portalName;
		if (brandInTracking === 'gmxde') {
			brandInTracking = 'gmx';
		}

		const paramObject = {
			name: 'homepage.startseite.event.' + currentEvent,
			portal: brandInTracking,
			country: window.PageConfig.country,
			pvid: window.SiteInfo.TrackLibPageId,
			login: 0, // ask
			var: document.querySelector('html').getAttribute('data-variant-name'),
			type: 'hidden', // ask
			teaser: teaserTrackString
		};

		const qaDomainAppendix = Helper.isLiveStage() ? '' : '-qa';
		let waDomain = `https://wa${qaDomainAppendix}.${window.SiteInfo.brandShort}.${window.SiteInfo.tld}/${window.SiteInfo.portalName}/${window.SiteInfo.portalName}/s`;

		try {
			window.__tcfapi(
				'getPermission',
				2,
				(valid) => {
					if (!valid) {
						if (paramObject.hasOwnProperty('pvid')) {
							paramObject.pvid = '';
						}
						if (paramObject.hasOwnProperty('var')) {
							paramObject.var = '';
						}
					}
				},
				'brainTracking'
			);
		} catch (e) {}

		waDomain += '?' + Helper.getParamsAsString(paramObject);
		this.trackImage(waDomain);

		/*
        How it should be done, when TrackLib works (maybe some adjustments vor keys)

        const trackObject = {
            name: 'homepage.startseite.event.' + currentEvent,
            portal: window.SiteInfo.brandShort,
            country: window.PageConfig.country,
            cont_page_id: window.SiteInfo.TrackLibPageId,
            login: 0, // ask
            var: 'default', // ask
            type: 'hidden', // ask
            teaser: teaserTrackString,
            visit_calc: 1
        };

        this.tracker.track(trackObject);
        */
	}

	getDataAttrValue (element, dataAttribute) {
		if (!element) return;

		if (element === document.body) {
			return;
		}

		if (element.hasAttribute(dataAttribute)) {
			return element.getAttribute(dataAttribute);
		} else {
			return this.getDataAttrValue(element.parentNode, dataAttribute);
		}
	}

	getParentElement (element, parentAttribute) {
		if (!element) return;

		if (!Element.prototype.matches) {
			Element.prototype.matches =
				Element.prototype.matchesSelector ||
				Element.prototype.mozMatchesSelector ||
				Element.prototype.msMatchesSelector ||
				Element.prototype.oMatchesSelector ||
				Element.prototype.webkitMatchesSelector ||
				function (s) {
					let matches = (this.document || this.ownerDocument).querySelectorAll(s);
					let i = matches.length;

					while (--i >= 0 && matches.item(i) !== this) {}
					return i > -1;
				};
		}

		if (element === document.body) {
			return undefined;
		}

		if (element.matches(parentAttribute)) {
			return element;
		} else {
			return this.getParentElement(element.parentNode, parentAttribute);
		}
	}

	getAndSetToolbarInfo (trackObject) {
		let toolbarInfo = {};
		toolbarInfo.kid = document.querySelector('html[united-toolbar-campaignid]').getAttribute('united-toolbar-campaignid');
		toolbarInfo.mode = document.querySelector('html[united-toolbar-mode]').getAttribute('united-toolbar-mode');
		toolbarInfo.variant = document.querySelector('html[united-toolbar-variant]').getAttribute('united-toolbar-variant');
		toolbarInfo.brand = document.querySelector('html[united-toolbar-brand]').getAttribute('united-toolbar-brand');
		toolbarInfo.bbrowser = document.querySelector('html[united-toolbar-branded-browser]').getAttribute('united-toolbar-branded-browser');
		toolbarInfo.version = document.querySelector('html[united-toolbar-version]').getAttribute('united-toolbar-version');
		toolbarInfo.accc = document.querySelector('html[united-toolbar-accountconfigured]').getAttribute('united-toolbar-accountconfigured');

		trackObject.cont_tb_campaign = '' + toolbarInfo.kid;
		trackObject.cont_tb_mode = '' + toolbarInfo.mode;
		trackObject.cont_tb_variant = '' + toolbarInfo.variant;
		trackObject.cont_tb_brand = '' + toolbarInfo.brand;
		trackObject.cont_tb_bbrowser = '' + toolbarInfo.bbrowser;
		trackObject.cont_tb_version = '' + toolbarInfo.version;
		trackObject.cont_tb_accc = '' + toolbarInfo.accc;
	}

	trackImage (url) {
		let track = new Image(1, 1);
		track.src = url;
	}

	trackTif () {
		let stage = window.PageConfig.stage === 'live' ? '2690' : '2255';
		let tifLibUrl = '//uim.tifbs.net/js/' + stage + '.js';

		this.addTifScript(tifLibUrl);
	}

	addTifScript (scriptSrc) {
		let head = document.getElementsByTagName('head')[0];
		let script = document.createElement('script');
		script.type = 'text/javascript';
		script.onload = function (event) {
			if (typeof window.NSfTIF !== 'undefined') {
				const tifTrack = {
					pageidentifier: 'homepage',
					// cc: AdService.params.region,
					region: window.PageConfig.country,
					deviceclass: 'desktop',
					brand: window.SiteInfo.portalName
				};

				window.NSfTIF.track(tifTrack);
			}
		};
		script.src = scriptSrc;
		head.appendChild(script);
	}

	addHashTracking () {
		let allTeasers = document.querySelectorAll('[data-component="teaser"]');

		allTeasers.forEach((element) => {
			if (!element.href.includes('#')) {
				let blockName = this.getDataAttrValue(element, 'data-name');
				if (blockName === 'viewport') {
					if (this.getParentElement(element, '[data-component="slider"]')) {
						blockName = 'hero';
					} else {
						blockName = 'pointOfViewTeaser';
					}
				} else {
					let blockNumber = this.getDataAttrValue(element, 'data-block-number');
					let blockLayoutName = this.getDataAttrValue(element, 'data-layout-name');
					blockName = blockLayoutName + '_' + blockNumber + '_' + blockName;
				}

				if (this.getReco() && element.getAttribute('data-reco-teaser') === '1') {
					blockName += '_treatSimple';
				}

				const hashparam = '#.homepage.' + blockName + '.' + element.getAttribute('data-short-headline') + '.' + element.getAttribute('data-teaser-number');

				if (blockName === 'hero') {
					const slider = this.getParentElement(element, '[data-component="slider"]');
					const miniPicture = slider.querySelector('li [href="' + element.attributes.href.value + '"]');

					if (miniPicture) {
						miniPicture.attributes.href.value = element.attributes.href.value + hashparam;
					}
				}

				element.href += hashparam;
			}
		});

		let blockNavigations = document.querySelectorAll('[data-component="block-navigation"]');

		blockNavigations.forEach((blockNavigation) => {
			let blockNavigationElements = blockNavigation.querySelectorAll('a');

			blockNavigationElements.forEach((element, index) => {
				if (!element.href.includes('#')) {
					let blockName = this.getDataAttrValue(element, 'data-name');
					let blockNumber = this.getDataAttrValue(element, 'data-block-number');
					let blockLayoutName = this.getDataAttrValue(element, 'data-layout-name');
					blockName = blockLayoutName + '_' + blockNumber + '_' + blockName;

					if (this.getReco() && element.getAttribute('data-reco-teaser') === '1') {
						blockName += '_treatSimple';
					}

					element.href += '#.homepage.' + blockName + '.' + element.innerHTML.trim() + '.' + (index + 1);
				}
			});
		});
	}

	getReco () {
		// control : treatment
		return window.PageConfig.reco === 'treatment';
	}
}

export { TrackingInterface };
